import { useFormik } from "formik";
import React from "react";
import {
  Button,
  FormFeedback,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import NewLetterService from "../../../services/KangarooServices/NewLetterService";
import toast from "react-hot-toast";
import * as Yup from "yup";

const NewsLetterForm = ({ isOpen, toggle, selectedCustomer, fetchdata }) => {
  console.log("🚀 ~ NewsLetterForm ~ selectedCustomer:", selectedCustomer)
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      email: selectedCustomer?.email || "",
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .email("Invalid email address")
        .required("Email is required"),
    }),
    onSubmit: async (values, { resetForm }) => {
      try {
        if (selectedCustomer?.id) {
          const response = await NewLetterService.update(values);
          toast.success(response || "Unsubscribed successfully");
        } else {
          const response = await NewLetterService.create(values);
          toast.success(response || "Subscribed successfully");
        }
        resetForm();
        fetchdata();
        toggle();
      } catch (error) {
        console.log(error);
        toast.error("Subscription failed");
      }
    },
  });

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered>
      <ModalHeader toggle={toggle}>Subscribe to Newsletter</ModalHeader>

      <form onSubmit={formik.handleSubmit}>
        <ModalBody>
          <FormGroup>
            <Label for="email">Email Address</Label>
            <Input
              id="email"
              name="email"
              type="email"
              placeholder="Enter your email"
              value={formik.values.email}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              invalid={formik.touched.email && Boolean(formik.errors.email)}
            />
            {formik.touched.email && formik.errors.email && (
              <FormFeedback>{formik.errors.email}</FormFeedback>
            )}
          </FormGroup>
        </ModalBody>

        <ModalFooter>
          <Button color="secondary" type="button" onClick={toggle}>
            Cancel
          </Button>
          <Button color="primary" type="submit">
            Subscribe
          </Button>
        </ModalFooter>
      </form>
    </Modal>
  );
};

export default NewsLetterForm;
